<template>
  <!-- 押金种类列表 -->
  <div class="dialog-root">
    <div class="container">
      <avue-crud ref="crud" :option="tableOption" :data="listData" @on-load="loadData">
        <template slot="radio" slot-scope="{ row }">
          <el-radio v-model="selectRowIndex" :label="row.$index">{{ '' }}</el-radio>
        </template>
      </avue-crud>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">确定</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getDepositTypeList } from '@/api/charge/deposit';

export default {
  name: 'DepositTypeList',
  props: ['propertyId'],
  data() {
    return {
      selectRowIndex: -1, // 选中的行对应的数据下标
      listData: [], // 列表数据
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '选择',
            prop: 'radio',
            width: 50,
            slot: true,
          },
          {
            label: '押金类型',
            prop: 'defItemset',
          },
          {
            label: '押金金额',
            prop: 'depositAmount',
            align: 'right',
          },
        ],
      },
    };
  },
  methods: {
    /* 加载列表数据 */
    loadData() {
      getDepositTypeList({
        propertyId: this.propertyId,
      }).then(({ data }) => {
        this.listData = data || [];
      });
    },
    doSave() {
      if (this.selectRowIndex < 0) {
        this.$message.warning('请先选择数据');
        return;
      }
      this.$emit('update', this.listData[this.selectRowIndex]);
      this.doClose();
    },
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
